import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{creatorId}/inbox']['GET'];

type Input = ThisApi['query'] & ThisApi['params'];

const getCreatorInboxItems = async ({
  search,
  page,
  perPage,
  types,
  isRead,
  creatorId,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/creators/${creatorId}/inbox`, {
    params: {
      page,
      perPage,
      search,
      types,
      isRead,
    },
  });
  return response.data;
};

export default getCreatorInboxItems;
